import { render } from "./uiDescriptionListTerm.vue?vue&type=template&id=94f807b4"
import script from "./uiDescriptionListTerm.vue?vue&type=script&lang=js"
export * from "./uiDescriptionListTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__